export class AdminResetPasswordRequest {
  accountId: number;
  password: string;
  confirmPassword: string;
}
